import './style.css';
import '../../../animation/animation-slide.css';

import { bind } from 'bind-decorator';
import React from 'react';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

class QuickPickContainer extends React.Component {
  render() {
    // tabindex is a hack to have blur events work correctly
    let { title, children, selected, transition, closeButton, headerContent, quickpickStyle } =
      this.props;

    let className = `back fa fa-chevron-left ${selected !== 'main' ? 'active' : ''}`;
    let close = <span />;
    if (closeButton) {
      close = (
        <div className="close" tabIndex="0" onClick={this.onRequestClose}>
          <span className="close-icon">&times;</span>
        </div>
      );
    }

    return (
      <div className="quick-pick-container">
        <div className="title">
          <div className={className} tabIndex="0" onClick={this.onBack} />
          <div className="text">{title}</div>
          {headerContent}
          {close}
        </div>
        <div className="body">
          <ReactCSSTransitionReplace
            transitionName={transition}
            transitionEnterTimeout={400}
            transitionLeaveTimeout={400}
            className={transition}
          >
            {children}
          </ReactCSSTransitionReplace>
        </div>
      </div>
    );
  }

  @bind
  onBack() {
    this.props.onBack();
  }

  @bind
  onRequestClose() {
    this.props.onRequestClose(true);
  }
}

QuickPickContainer.defaultProps = {
  selected: 'main',
  title: '',
  transition: 'slide-right',
  onBack: () => {},
  onRequestClose: () => {}
};

export default QuickPickContainer;

export const { defaultProps } = QuickPickContainer;

export { QuickPickContainer };
